export const companyTypeConstants = {
  DEMO: 'DEMO',
  TRIAL: 'TRIAL',
  PDQ: 'PDQ',
  PROD: 'PROD',
  SANDBOX: 'SANDBOX',
  GUIDED_TRIALS: 'GUIDED_TRIALS',
};

export const companyTrialStatusConstants = {
  IN_PROGRESS: 'IN_PROGRESS',
  EXPIRED: 'EXPIRED',
}

export const companyTrialStatusMap = {
  [companyTrialStatusConstants.IN_PROGRESS]: 'In progress',
  [companyTrialStatusConstants.EXPIRED]: 'Expired'
};

/**
 * Company type constants
 * See ticket ALP-2945 for details
 */
export const companyTypes = [
  // Implementation's and Sales' demo environments should go here
  { value: 'DEMO', title: 'Demo' },
  // trial tenant accounts (same as previous)
  { value: 'TRIAL', title: 'Trial' },
  // Combine all three of these into one tenant type = PDQ, which Product, Dev, and QA will use to house their testing tenants
  // (previously 'dev', 'qa' and 'product')
  { value: 'PDQ', title: 'PDQ' },
  // production tenants (previously 'live')
  { value: 'PROD', title: 'PROD' },
  // production tenants (previously 'sandbox')
  { value: 'SANDBOX', title: 'SANDBOX' },
  // guided trials
  { value: 'GUIDED_TRIALS', title: 'G.Trials' },
];
